
  import { mapActions, mapState } from 'vuex'

  import IconWindowBorderless from '@loavies/component-library/dist/icons/icon-window-borderless'
  import IconSquareBorderless from '@loavies/component-library/dist/icons/icon-square-borderless'

  export default {
    components: {
      IconWindowBorderless,
      IconSquareBorderless,
    },
    computed: {
      ...mapState({
        showLargeProductCards: state => state.showLargeProductCards,
        isUserInitialized: state => state.user.isInitialized,
      }),
    },
    methods: {
      ...mapActions({
        setShowLargeProductCards: 'setShowLargeProductCards',
      }),
    },
  }
